import uiNotifications from 'services/uiNotification.service';
import ModalManager from '@ebay/nice-modal-react';

export default function process(response) {
  if (!response.error) {
    return response;
  }

  if ([400, 422].includes(response.error.status)) {
    uiNotifications.showError(response.error.message);
    return {
      ...response,
      isBadRequest: true,
      errorMessage: response.error.message,
    };
  }

  if (response.status === 401 || response.error.status === 401) {
    ModalManager.show('signin-modal');
  }

  throw response.error;
}
